
<main class="agpr-accountPreferences">
    <header class="agpr-accountPreferences-head">
        <h1>
            <span class="agpr-accountPreferences-head-title"> {{ 'Core.navigation.account.accountPreferences' | localize }} </span>
        </h1>
    </header>

    <div class="agpr-accountPreferences-tabs">
        <agpr-tabs
            [selectedTabIndex]="selectedTabIndex"
            (selectedTabIndexChange)="tabIndexChange($event)"
            [useContentContainer]="false"
            (tabChange)="tabChange($event)"
            [tabsHeadingLevel]="3"
        >
            @if (hasMonitoring) {
                <agpr-tab
                    [id]="tabIds.MONITOR_SETTINGS"
                    [heading]="'AccountPreferences.monitoring'"
                ></agpr-tab>
            }
        </agpr-tabs>
    </div>

    <section
        class="agpr-accountPreferences-main"
        [agprLoading]="loading"
    >
        <div class="agpr-accountPreferences-main-lhp">
            <agpr-scroll-panel>
                <div class="agpr-accountPreferences-main-lhp-content">
                    @if (selectedTabId === tabIds.MONITOR_SETTINGS) {
                        <div>
                            <ng-container
                                *ngTemplateOutlet="list; context: {listItems: monitoringListItems}"
                            ></ng-container>
                        </div>
                    }
                </div>
            </agpr-scroll-panel>
        </div>
        <div class="agpr-accountPreferences-main-rhp">
            <agpr-scroll-panel #scrollPanel>
                <div class="agpr-accountPreferences-main-rhp-content">
                    @if (selectedTabId === tabIds.MONITOR_SETTINGS) {
                        <div>
                            <agpr-monitoring-account-preferences
                                (sectionListItems)="updateSectionListItems('monitoringListItems', $event)"
                            ></agpr-monitoring-account-preferences>
                        </div>
                    }
                </div>
            </agpr-scroll-panel>
        </div>
    </section>
</main>

<ng-template #list let-listItems="listItems">
    <div class='agpr-accountPreferences-main-lhp-listContainer'>
        <ul class="agpr-accountPreferences-main-lhp-listContainer-list">
            <li
                *ngFor="let item of listItems; index as i"
                class="agpr-accountPreferences-main-lhp-listContainer-item"
                tabindex="0"
                (keydown)="scrollToSection(item.value, $event)"
                (click)="scrollToSection(item.value)"
            >
                <!-- Will add click event to trigger scroll to position -->
                <a
                    class="agpr-accountPreferences-main-lhp-listContainer-itemLabel"
                    id="leftSidebar.item_{{ i }}"
                >
                    {{ item.label | localize }}
                </a>
            </li>
        </ul>
    </div>
</ng-template>
